/**
 * @generated SignedSource<<0a9103dd2faed088b771704e078fbd39>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type Row_job$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Jobs_organization$fragmentType: FragmentType;
export type Jobs_organization$data = {|
  +jobs?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id?: string,
        +$fragmentSpreads: Row_job$fragmentType,
      |},
    |}>,
    +pageInfo: ?{|
      +hasNextPage: boolean,
    |},
  |},
  +name: string,
  +slug: string,
  +$fragmentType: Jobs_organization$fragmentType,
|};
export type Jobs_organization$key = {
  +$data?: Jobs_organization$data,
  +$fragmentSpreads: Jobs_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "agentQueryRules"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "concurrency"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isMounted"
    },
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "passed"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priority"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "states"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Jobs_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "condition": "isMounted",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "agentQueryRules",
              "variableName": "agentQueryRules"
            },
            {
              "kind": "Variable",
              "name": "concurrency",
              "variableName": "concurrency"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            {
              "kind": "Variable",
              "name": "passed",
              "variableName": "passed"
            },
            {
              "kind": "Variable",
              "name": "priority",
              "variableName": "priority"
            },
            {
              "kind": "Variable",
              "name": "state",
              "variableName": "states"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "COMMAND"
            }
          ],
          "concreteType": "JobConnection",
          "kind": "LinkedField",
          "name": "jobs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JobEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        }
                      ],
                      "type": "JobTypeCommand",
                      "abstractKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "Row_job"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node/*: any*/).hash = "6a8dce972d078c1fbc9ad2eac6029c8c";

module.exports = ((node/*: any*/)/*: Fragment<
  Jobs_organization$fragmentType,
  Jobs_organization$data,
>*/);
